import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const AccordionFlex = styled(Flex)`
  .ask-br {
    display: none;
    @media (min-width: 360px) {
      display: block;
    }
  }
`

export const AccordionWrapper = styled.div`
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -0.5px;
    width: 100%;
    height: 8px;
    border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -0.5px;
    width: 100%;
    height: 8px;
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`
